import { SettingKey } from 'data/ppoints/constants';
import { useEmbeddedStatusSwr } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import useSettings from 'hooks/useSettings';
import { IntegrationModeSetting } from 'models/ppoints/settings/SettingsToEcom';
import { useMemo } from 'react';
import { AfterCheckupPointIntegrations } from '../after-checkout-pickup-point-integrations/AfterCheckoutPickupPointIntegrations';
import { CartIntegrations } from '../cart-integrations/CartIntegrations';
import { CheckoutAppIntegration } from '../checkout-map-integration/CheckoutAppIntegration';
import { SelectedPackagePointIntegrations } from '../selected-package-ppoint-intergations/SelectedPackagePointIntegrations';
import { SmartDeliveryPageIntegration } from '../smart-delivery-page-integration/SmartDeliveryPageIntegration';

export const IntegrationStatusList: React.FC<IntegrationStatusListProps> = (props) => {
    const {
        data,
        isLoading: isLoadingExtensions,
        isValidating,
    } = useEmbeddedStatusSwr(props.autoRefresh ? { refreshInterval: 8000, revalidateOnFocus: true } : null);
    const setting = useSettings<IntegrationModeSetting>(SettingKey.integration_mode);

    const integrationMode = useMemo<IntegrationModeSetting>(() => setting.settings, [setting.settings]);

    const isLoading = useMemo(
        () => (isLoadingExtensions || isValidating) && !props.autoRefresh,
        [isLoadingExtensions, isValidating, props.autoRefresh]
    );

    if (!integrationMode) {
        return null;
    }

    return (
        <div className="flex flex-col">
            {integrationMode === IntegrationModeSetting.map && (
                <>
                    <CartIntegrations
                        extensions={data}
                        isLoading={isLoading}
                        condensed={props.condensed}
                        hideOptional={props.hideOptional}
                        handleClickAddStoreAppBlock={props.handleClickAddStoreAppBlock}
                    />
                </>
            )}
            {integrationMode === IntegrationModeSetting.smart_delivery_page && (
                <SmartDeliveryPageIntegration
                    extensions={data}
                    isLoading={isLoading}
                    condensed={props.condensed}
                    handleClickAddStoreAppBlock={props.handleClickAddStoreAppBlock}
                />
            )}
            {integrationMode === IntegrationModeSetting.checkout_map && (
                <>
                    <CheckoutAppIntegration
                        extensions={data}
                        isLoading={isLoading}
                        condensed={props.condensed}
                        handleClickAddStoreAppBlock={props.handleClickAddStoreAppBlock}
                    />
                </>
            )}

            {integrationMode === IntegrationModeSetting.thank_you_page_map && (
                <>
                    <AfterCheckupPointIntegrations
                        extensions={data}
                        isLoading={isLoading}
                        condensed={props.condensed}
                        handleClickAddStoreAppBlock={props.handleClickAddStoreAppBlock}
                    />
                </>
            )}

            {!props.hideOptional && (
                <>
                    <s-divider />
                    <SelectedPackagePointIntegrations
                        extensions={data}
                        isLoading={isLoading}
                        condensed={props.condensed}
                        handleClickAddStoreAppBlock={props.handleClickAddStoreAppBlock}
                    />
                </>
            )}
        </div>
    );
};

interface IntegrationStatusListProps {
    condensed?: boolean;
    hideOptional?: boolean;
    autoRefresh?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
